import * as _ from 'lib/underscore';
import {Router, NavUrl} from 'core/utils/nav/router';
import {Query} from 'core/utils/nav/query';
import {Loader} from "core/utils/nav/loader";

// const logger = loggerUtils.newLogger('Navigator');

class ShopQuery extends Query {
	setCategory(category, reset = false) {
		this.setSubcategory(category, null, reset);
	}

	getCategory() {
		return this.getQueryParam('category');
	}

	setSubcategory(category, subcategory, reset = false) {
		this.setQuery({category, subcategory}, reset);
	}

	getSubcategory() {
		return this.getQueryParam('subcategory');
	}

	addBrand(brand) {
		this.addValue('brand', brand);
	}

	toggleBrand(brand) {
		this.toggleValue('brand', brand);
	}

	getBrands() {
		return this.getQueryParamAsArray('brand');
	}

	addShop(shop) {
		this.addValue('shop', shop);
	}

	toggleShop(shop) {
		this.toggleValue('shop', shop);
	}

	setShop(shop) {
		this.setQuery({shop});
	}

	getShops() {
		return this.getQueryParamAsArray('shop');
	}

	setMinPrice(min_price) {
		this.setQuery({min_price});
	}

	getMinPrice() {
		return this.getQueryParam('min_price');
	}

	setMaxPrice(max_price) {
		this.setQuery({max_price});
	}

	getMaxPrice() {
		return this.getQueryParam('max_price');
	}

	getAttributeValues(attr) {
		return this.getQueryParamAsArray(attr);
	}

	toggleAttribute(attr, value) {
		this.toggleValue(attr, value);
	}

	setSortBy(sort) {
		this.setQuery({sort});
	}

	getSortBy() {
		return this.getQueryParam('sort');
	}

	setLimit(limit, page = null) {
		this.setQuery({limit, page});
	}

	getLimit() {
		return this.getQueryParam('limit');
	}

	setPage(page) {
		this.setQuery({page});
	}

	getPage() {
		return this.getQueryParam('page');
	}

	getPageUrl(page) {
		return this.generateUrl({page});
	}

	setLayout(layout) {
		this.setQuery({layout});
	}

	getLayout() {
		return this.getQueryParam('layout');
	}

	getSearch() {
		return this.getQueryParam('search');
	}

	setSearch(search) {
		// don't reset the query if search is empty
		return this.setQuery({search}, !!search);
	}

	getSearchResults() {
		return this.getQueryParam('search_results');
	}

	setSearchResults(search_results) {
		return this.setQuery({search_results});
	}

	setParam(param, value) {
		const query = {};
		query[param] = value;
		return this.setQuery(query);
	}

	setQuery(params, reset) {
		if (!reset) {
			// reset page
			if (params.page === undefined) {
				params.page = null;
			}
		}
		return super.setQuery(params, reset);
	}

	_constructUrl(selection) {
		let path = '';
		if (selection.category) {
			path += '/' + selection.category;
			if (selection.subcategory) {
				path += '/' + selection.subcategory;
			}
			selection = _.omit(selection, 'category', 'subcategory');
		}
		const url = super._constructUrl(selection);
		return new NavUrl(path, url.queryData);
	}
}

/** @var {Router} */
export const router = new Router();
/** @var {ShopQuery} */
export const query = new ShopQuery(router);
/** @var {Loader} */
export const loader = new Loader(router);

export function init(baseUrl, apiUrl) {
	router.init(baseUrl);
	loader.apiUrl = apiUrl;
}



// WEBPACK FOOTER //
// ./modules/shop/catalog/navigator.js